"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultScreenLayout = void 0;
const Flex_1 = __importStar(require("@targetx/mineral-ui/Flex"));
const palette_1 = __importDefault(require("@targetx/mineral-ui/themes/generated/palette"));
const Image_1 = __importDefault(require("@targetx/tx-web-ui-lib/lib/components/Image"));
const react_1 = __importDefault(require("react"));
const theme_1 = __importDefault(require("../../theme"));
function DefaultScreenLayout({ children }) {
    return (react_1.default.createElement(Flex_1.default, { alignItems: "stretch", backgroundColor: palette_1.default.white, breakpoints: ['medium'], direction: ['column', 'row'], height: "100%" },
        react_1.default.createElement(Flex_1.FlexItem, { alignItems: "center", backgroundColor: palette_1.default.blue[100], breakpoints: ['medium'], flex: true, grow: [0, 1], height: ['125px', '100%'], justifyContent: "center", marginRight: 0, paddingVertical: theme_1.default.space_stack_md, width: [undefined, '50%'] },
            react_1.default.createElement(Image_1.default, { src: "tx-common-logo.6a64d3f9.svg", alt: "TargetX", height: "4em" })),
        react_1.default.createElement(Flex_1.FlexItem, { flex: true, grow: 1, justifyContent: "center", marginHorizontal: theme_1.default.space_inline_md, width: "50%" }, children)));
}
exports.DefaultScreenLayout = DefaultScreenLayout;
exports.default = DefaultScreenLayout;
